<template>
  <v-container>
    <h1>Profiles</h1>
    <v-container class="pa-6 pt-10" fluid>
      <v-container fluid>
        <v-row>
          <v-col cols="6" class="d-flex align-center">
            <v-img max-width="65" contain src="./assets/olympiclogo.svg" />
            <p class="pl-4 ma-0">MANAGE TEAM</p>
          </v-col>
          <v-col cols="6" align="right">
            <p class="pl-4 ma-0">TOKYO 2020</p>
            <p class="pl-4 ma-0">August 24 - September 5 2021</p>
          </v-col>
        </v-row>
      </v-container>
      <List
        :UserList="LoadUsers()"
        :showList="showList"
      />
    </v-container>
  </v-container>
</template>

<script>
import List from "../../components/UserProfiles/List.vue";
import UserListJson from "../../components/UserProfiles/UserList.json";

export default {
  name: "Profiles",
  route: {
    path: "/profiles/",
    name: "Profiles",
  },
  data() {
    return {
      showList: ["name", "role", "created", "status"],
      showEdit: ["name", "role", "created", "status"],
    };
  },
  components: {
    List,
  },
  methods: {
    LoadUsers: () => {
      return UserListJson;
    },
  },
};
</script>

<style></style>
